import React, { useState, useEffect } from 'react';
import { CButton, CCard, CCardBody, CCardFooter, CCol, CRow, CModal, CModalBody, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react';

import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import $axios from 'src/utils/axios';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Swal from 'sweetalert2/dist/sweetalert2.js';
import IP from '../../StoreGlobal/IP';
import 'react-datepicker/dist/react-datepicker.css';
import { showError } from 'src/utils/swalError';
import { FaTimes, FaReply, FaPaperclip, FaImage, FaFileWord, FaFileExcel, FaFilePowerpoint, FaFilePdf, FaFileCsv, FaEllipsisV, FaFileAlt, FaPencilAlt, FaTrashAlt } from 'react-icons/fa';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import likeIcon from 'src/assets/img/like.png';
import unlikeIcon from 'src/assets/img/unlike.png';
import { getUpdates, postUpdates, postReply, posLike, deletePost, getUsers, Update } from 'src/request/Updates';
import useCustomPagination from 'src/utils/useCustomPagination';
import { debounce } from 'lodash';
import { MentionsInput, Mention } from 'react-mentions';
import { useParams } from 'react-router-dom';
import ProjectTabs from '../projects/ProjectTabs';
import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';
const defaultStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },

  '&multiLine': {
    control: {
      minHeight: 80,
    },
    highlighter: {
      padding: 12,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '1.5',
      whiteSpace: 'pre-wrap',
    },
    input: {
      padding: 12,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '1.5',
      margin: 0,
    },
  },

  '&singleLine': {
    display: 'inline-block',
    width: 220,

    highlighter: {
      padding: '4px 8px',
      fontSize: 14,
      lineHeight: '1.5',
    },
    input: {
      padding: '4px 8px',
      fontSize: 14,
      lineHeight: '1.5',
      borderRadius: 6,
      border: '1px solid #d0d5dd',
    },
  },

  suggestions: {
    list: {
      backgroundColor: '#ffffff',
      border: '1px solid #e4e7ec',
      borderRadius: 8,
      boxShadow: '0 4px 6px rgba(16, 24, 40, 0.1)',
      fontSize: 14,
      maxHeight: 200,
      overflowY: 'auto',
      marginTop: 4,
    },
    item: {
      padding: '10px 26px',
      cursor: 'pointer',
      color: '#344054',
      '&focused': {
        backgroundColor: '#e0f2ff',
        color: '#1d2939',
      },
    },
  },
};

const defaultMentionStyle = {
  backgroundColor: '#cee4e5',
  padding: '0.2375rem 0 0.2375rem 0',
};

const Updates = (props) => {
  let company_id = parseInt(localStorage.getItem('company_id'));
  let user_id = parseInt(localStorage.getItem('user_id'));
  const projectID = parseInt(useParams().id, 10);
  let now = Date.now();
  let date = new Date(now).toLocaleString('en-US', {
    hour12: false,
  });

  const [read, setRead] = useState('read-more');
  const [file, setFile] = useState([]);
  const [docs, setdocs] = useState([]);
  const [fileReply, setFileReply] = useState([]);
  const [docsReply, setdocsReply] = useState([]);
  const [showImage, setShowImage] = useState(false);
  const [imagePreview, setImagePreview] = useState();
  const [showPost, setShowPost] = useState(false);
  const [showReply, setShowReply] = useState();
  const [showReplyEdit, setShowReplyEdit] = useState(-1);
  const [notes, setnotes] = useState('');
  const [imageUpload, setImageUpload] = useState([]);
  const [fileUpload, setFileUpload] = useState([]);
  const [profilePic, setProfilePic] = useState();
  const [fullName, setFullName] = useState();
  const [updatesData, setUpdatesData] = useState([]);
  const [hoverDelet, setHoverDelete] = useState();

  const [replyfileObj, setReplyFileObject] = useState([]);
  const [replydocsFileObj, setReplydocsFileObj] = useState([]);
  const [buttonChange, setButtonChange] = useState('save');
  const [replyButtonChange, setReplyButtonChange] = useState('save');
  const [replyValue, setReplyValue] = useState();
  const [removeImg, setRemoveImg] = useState([]);
  const [removeFile, setRemoveFile] = useState([]);
  const [removeImgReply, setRemoveImgReply] = useState([]);
  const [removeFileReply, setRemoveFileReply] = useState([]);

  const [postId, setPostId] = useState();
  const [replyId, setReplyId] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState();
  const [users, setUsers] = useState('');
  const { currentPage, pageSize, totalPages, searchTerm, updatePagination } = useCustomPagination();

  useEffect(() => {
    let user_id = parseInt(localStorage.getItem('user_id'));
    GetUsersById(user_id);
    getPost(projectID, limit);
  }, []);

  useEffect(() => {
    GetAllUsers();
  }, [searchTerm]);

  const handleSearch = debounce((e) => {
    updatePagination({ newSearchTerm: e, newCurrentPage: 1 });
  }, 500);

  const fetchUsers = async (query, callback) => {
    await handleSearch(query);
    callback(users);
  };

  const GetAllUsers = () => {
    getUsers({ page: currentPage, per_page: pageSize, search_term: searchTerm }).then((res) => {
      if (res?.status == 200) {
        let data = res?.data?.[0]?.data;
        let arr = [];
        data.forEach((user) => {
          arr.push({
            id: user.value,
            display: user.label,
          });
        });
        let totalPages_ = res?.data?.total_pages ?? 0;
        if (totalPages !== totalPages_) {
          updatePagination({ newTotalPages: totalPages_ });
        }
        setUsers(arr);
      }
    });
  };

  const getPost = (projectId, limit) => {
    getUpdates(projectId, page, limit).then(function (response) {
      if (response.data.status == 1) {
        setUpdatesData(response.data.response.data);
        setTotalItems(response.data.response.total_items);
      }
    });
  };

  const GetUsersById = (user_id) => {
    $axios
      .post(IP + 'account/user/info', {
        user_id,
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(function (response) {
        if (response.data.status == 1) {
          setFullName(response.data.response.full_name);

          setProfilePic(response.data.response.profile_pic);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.log('Profile/about-me/AboutME.js', ' ', 'line 150', error);
      });
  };
  const saveUpdate = () => {
    let data = {
      message: notes,
      date_time: date.replace(',', ''),
      company_id: company_id,
      user_id: user_id,
      project_id: projectID,
    };

    let formData = new FormData();
    formData.append('data', JSON.stringify(data));

    for (let i = 0; i < imageUpload.length; i++) {
      formData.append(`img`, imageUpload[i], imageUpload[i].name);
    }

    for (let i = 0; i < fileUpload.length; i++) {
      formData.append(`file`, fileUpload[i]);
    }

    postUpdates(formData).then(function (response) {
      if (response.data.status == 1) {
        trackEvent(mixPanelEvents.POST_PROJECT_UPDATE, {
          'Source': 'Project - Updates',
          'project_id': data.project_id,
          'message': data.message,
          'date_time': data.date_time,
          'action_type': 'comment',
        })
        getPost(projectID, limit);
        setImageUpload([]);
        setFileUpload([]);
        setnotes('');
        setFile([]);
        setdocs([]);
        setShowPost(false);
      }
    });
  };

  const updatePost = () => {
    let formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('message', notes);
    formData.append('remove_img', JSON.stringify(removeImg));
    formData.append('remove_file', JSON.stringify(removeFile));

    for (let i = 0; i < imageUpload.length; i++) {
      formData.append(`img`, imageUpload[i], imageUpload[i].name);
    }

    for (let i = 0; i < fileUpload.length; i++) {
      formData.append(`file`, fileUpload[i]);
    }
    Update(formData, 'post', postId).then((response) => {
      if (response.data.status == 1) {
        getPost(projectID, limit);
        setImageUpload([]);
        setFileUpload([]);
        setnotes('');
        setFile([]);
        setdocs([]);
        setShowPost(false);
      }
    });
  };

  const updateReply = () => {
    let data = {
      message: replyValue,
    };
    let formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('message', replyValue);
    formData.append('remove_img', JSON.stringify(removeImgReply));
    formData.append('remove_file', JSON.stringify(removeFileReply));

    for (let i = 0; i < replyfileObj.length; i++) {
      formData.append(`img`, replyfileObj[i], replyfileObj[i].name);
    }

    for (let i = 0; i < replydocsFileObj.length; i++) {
      formData.append(`file`, replydocsFileObj[i]);
    }

    Update(formData, 'reply', replyId).then((response) => {
      if (response.data.status == 1) {
        getPost(projectID, limit);
        setReplyValue('');
        setReplyFileObject([]);
        setReplydocsFileObj([]);
        setRemoveImgReply([]);
        setRemoveFileReply([]);
        setShowReplyEdit(-1);
        setShowPost(false);
      }
    });
  };

  const ReplyUpdate = (pos_id) => {
    const data = {
      project_id: projectID,
      company_id: company_id,
      post_id: pos_id,
      message: replyValue,
      date_time: date.replace(',', ''),
      user_id: user_id,
    };

    let formData = new FormData();
    formData.append('data', JSON.stringify(data));

    for (let i = 0; i < replyfileObj.length; i++) {
      formData.append(`img`, replyfileObj[i], replyfileObj[i].name);
    }

    for (let i = 0; i < replydocsFileObj.length; i++) {
      formData.append(`file`, replydocsFileObj[i]);
    }

    postReply(formData).then(function (response) {
      if (response.data.status == 1) {
        trackEvent(mixPanelEvents.REPLY_PROJECT_UPDATE, {
          'Source': 'Project - Updates',
          'data': formData
        })
        formData = new FormData();
        setReplyFileObject([]);
        setReplydocsFileObj([]);
        setFileReply([]);
        setdocsReply([]);
        setReplyValue('');
        setShowReply(-1);
        getPost(projectID, limit);
      } else {
        Swal.fire({
          icon: 'error',
          title: response.data.response,
          text: response.data.description,
          confirmButtonColor: '#23303D',
        });
      }
    });
  };

  const EditPost = (post_id) => {
    setPostId(post_id);

    let arr = [...updatesData];
    let img_arr = [];
    let file_arr = [];

    let Index = arr.findIndex((a) => a.post_id == post_id);

    for (var i in arr[Index].img) {
      img_arr.push({
        name: arr[Index].img[i]['name'],
        link: arr[Index].img[i]['link'],
      });
    }

    for (var i in arr[Index].file) {
      file_arr.push(arr[Index].file[i]['name']);
    }

    setdocs(file_arr);

    setFile(img_arr);
    setShowPost(true);
  };

  const editReply = (val, rep_id, post_id) => {
    setReplyId(rep_id);
    setPostId(post_id);
    setShowReplyEdit(val);
    let arr = [...updatesData];
    let img_arr = [];
    let file_arr = [];
    let p_index = arr.findIndex((a) => a.post_id == post_id);

    let r_index = arr[p_index]['reply'].findIndex((a) => a.reply_id == rep_id);

    setReplyValue(arr[p_index]['reply'][r_index]['reply']);

    for (var i in arr[p_index]['reply'][r_index]['img']) {
      img_arr.push(arr[p_index]['reply'][r_index]['img'][i]);
    }

    for (var i in arr[p_index]['reply'][r_index]['file']) {
      file_arr.push(arr[p_index]['reply'][r_index]['file'][i]);
    }

    setFileReply(img_arr);
    setdocsReply(file_arr);
  };

  const removeUpdates = (post_id, category) => {
    Swal.fire({
      icon: 'question',
      title: `Do you want to remove this ${category}?`,
      showCancelButton: true,
      confirmButtonColor: '#23303D',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {
        deletePost(post_id, category).then((res) => {
          if (res.data.status == 1) {
            getPost(projectID, limit);
            Swal.fire({
              icon: 'success',
              title: `${category}  Deleted`,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
    });
  };

  const like = (post_id, user_id, val) => {
    let data = {
      post_id,
      user_id,
      action: val,
    };
    posLike(data).then((res) => {
      trackEvent(mixPanelEvents.LIKE_PROJECT_UPDATE, {
        'Source': 'Project - Updates',
        'data': data
      })
      getPost(projectID, limit);
    });
  };

  const upload = (e) => {
    let new_arr = [];
    let arr = [...imageUpload];
    let img_arr = [...file];

    new_arr.push(e.target.files);

    for (let i = 0; i < e.target.files.length; i++) {
      arr.push(e.target.files[i]);
    }
    setImageUpload(arr);

    for (let i = 0; i < new_arr[0].length; i++) {
      img_arr.push({
        name: new_arr[0][i].name,
        link: URL.createObjectURL(new_arr[0][i]),
      });
    }

    setFile(img_arr);
  };

  const uploadFiles = (e) => {
    let new_arr = [];
    let arr = [...fileUpload];
    let arr_docs = [...docs];

    new_arr.push(e.target.files);
    for (var i in e.target.files) {
      arr.push(e.target.files[i]);
    }
    setFileUpload(arr);

    for (let i = 0; i < new_arr[0].length; i++) {
      arr_docs.push(new_arr[0][i]['name']);
    }

    setdocs(arr_docs);
  };

  const uploadFilesReply = (e) => {
    let new_arr = [];
    let arr = [...replydocsFileObj];
    let arr_docs = [...docsReply];

    new_arr.push(e.target.files);
    for (var i in e.target.files) {
      arr.push(e.target.files[i]);
    }

    setReplydocsFileObj(arr);

    for (let i = 0; i < new_arr[0].length; i++) {
      arr_docs.push({ name: new_arr[0][i]['name'], link: '' });
    }

    setdocsReply(arr_docs);
  };

  const uploadReply = (e) => {
    let new_arr = [];
    let arr = [...replyfileObj];
    let arr_img = [...fileReply];
    new_arr.push(e.target.files);
    for (let i = 0; i < e.target.files.length; i++) {
      arr.push(e.target.files[i]);
    }
    setReplyFileObject(arr);
    for (let i = 0; i < new_arr[0].length; i++) {
      arr_img.push({
        name: new_arr[0][i]['name'],
        link: URL.createObjectURL(new_arr[0][i]),
      });
    }

    setFileReply(arr_img);
  };

  const clickImagePreview = (link) => {
    setShowImage(true);
    setImagePreview(link);
  };

  const loadMore = () => {
    setLimit(limit + 10);
    getPost(projectID, limit + 10);
  };

  const remove = (name) => {
    let arr = [...file];
    let imgarr = [...imageUpload];
    let remove = [...removeImg];

    let data = arr.filter((a) => a.name != name);

    let findIndex = imgarr.findIndex((a) => a.name == name);
    if (findIndex == -1) {
      remove.push(name);
      setRemoveImg(remove);
    }

    if (imgarr.length > 0) {
      let dataImg = imgarr.filter((a) => a.name != name);
      setImageUpload(dataImg);
    }

    setFile(data);
  };

  const removeReplyImage = (name) => {
    let arr = [...replyfileObj];
    let arr_img = [...fileReply];
    let remove = [...removeImgReply];

    let filter = arr_img.filter((a) => a.name != name);

    let findIndex = arr.findIndex((a) => a.name == name);

    if (findIndex == -1) {
      remove.push(name);

      setRemoveImgReply(remove);
    }

    if (arr.length > 0) {
      let dataImg = arr.filter((a) => a.name != name);

      setReplyFileObject(dataImg);
    }

    setFileReply(filter);
  };

  const removeDocs = (name) => {
    let arr = [...fileUpload];
    let arr_docs = [...docs];
    let remove = [...removeFile];

    let filter = arr_docs.filter((a) => a != name);

    let findIndex = arr.findIndex((a) => a.name == name);

    if (findIndex == -1) {
      remove.push(name);

      setRemoveFile(remove);
    }

    if (arr.length > 0) {
      let fileData = arr.filter((a) => a.name != name);

      setFileUpload(fileData);
    }

    setdocs(filter);
  };

  const removeReplyFile = (name) => {
    let arr = [...replydocsFileObj];
    let arr_docs = [...docsReply];
    let remove = [...removeFileReply];

    let filter = arr_docs.filter((a) => a.name != name);

    let findIndex = arr.findIndex((a) => a.name == name);

    if (findIndex == -1) {
      remove.push(name);
      setRemoveFileReply(remove);
    }

    if (arr.length > 0) {
      let fileData = arr.filter((a) => a.name != name);
      setReplydocsFileObj(fileData);
    }

    setdocsReply(filter);
  };

  const noteChange = (e, val) => {
    setnotes((prevValue) => e);
  };

  const ImgUpload = file.map((url, Index) => {
    return (
      <CCol md="4" key={Index} style={{ padding: '10px' }} className="div-image">
        <i className="div-icon">
          <FaTimes style={{ height: '20px', width: '20px' }} onClick={() => remove(url.name)} />
        </i>
        <img src={url.link} style={{ width: '100%', height: '100px' }} />
      </CCol>
    );
  });

  const docsPreview = docs.map((name, Index) => {
    let ex = name.split('.').pop();

    return (
      <CCol md="3" key={Index} style={{ textAlign: 'center' }} className="div-image">
        <i className="div-icon">
          <FaTimes style={{ height: '20px', width: '20px' }} onClick={() => removeDocs(name)} />
        </i>
        {(ex == 'docx' || ex == 'doc') && <FaFileWord style={{ width: '30px', height: '50px' }} />}
        {(ex == 'xlsx' || ex == 'xls') && <FaFileExcel style={{ width: '30px', height: '50px' }} />}

        {(ex == 'ppt' || ex == 'pptx') && <FaFilePowerpoint style={{ width: '30px', height: '50px' }} />}
        {ex == 'pdf' && <FaFilePdf style={{ width: '30px', height: '50px' }} />}
        {ex == 'csv' && <FaFileCsv style={{ width: '30px', height: '50px' }} />}
        {ex == 'txt' && <FaFileAlt style={{ width: '30px', height: '50px' }} />}

        <div>
          <span style={{ fontSize: '12px' }}>{name}</span>
        </div>
      </CCol>
    );
  });

  const ReplyImgUpload = fileReply.map((url, Index) => {
    return (
      <CCol md="2" key={Index} style={{ marginTop: '10px' }}>
        <i className="div-icon-reply">
          <FaTimes style={{ height: '20px', width: '20px' }} onClick={() => removeReplyImage(url.name)} />
        </i>
        <img src={url.link} style={{ width: '100%', height: '50px' }} />
      </CCol>
    );
  });

  const ReplydocsPreview = docsReply.map((name, Index) => {
    let ex = name.name.split('.').pop();

    return (
      <CCol md="2" key={Index} style={{ textAlign: 'center' }}>
        <i className="div-icon-reply">
          <FaTimes style={{ height: '20px', width: '20px' }} onClick={() => removeReplyFile(name.name)} />
        </i>
        {(ex == 'docx' || ex == 'doc') && <FaFileWord style={{ width: '20px', height: '40px' }} />}
        {(ex == 'xlsx' || ex == 'xls') && <FaFileExcel style={{ width: '20px', height: '40px' }} />}

        {(ex == 'ppt' || ex == 'pptx') && <FaFilePowerpoint style={{ width: '20px', height: '40px' }} />}
        {ex == 'pdf' && <FaFilePdf style={{ width: '20px', height: '40px' }} />}
        {ex == 'csv' && <FaFileCsv sstyle={{ width: '20px', height: '40px' }} />}

        <div>
          <span style={{ fontSize: '10px' }}>{name.name}</span>
        </div>
      </CCol>
    );
  });

  const Updates = updatesData.map((data, Index) => {
    let str = data.note.split('\n');

    let p_index = Index;

    let imagelength = data['img'].length;
    let row = 4;

    const imageFile = data['img'].map((image, Index) => {
      if (imagelength == 1) {
        row = 12;
      } else if (imagelength == 2) {
        row = 6;
      }

      return (
        <CCol md={row} key={Index} style={{ padding: '5px' }}>
          <img
            src={image.link}
            style={{
              width: '100%',
              height: '100%',
              borderStyle: 'solid',
              borderWidth: '1px',
              borderColor: '#DEDEE1',
            }}
            onClick={() => clickImagePreview(image.link)}
          />
        </CCol>
      );
    });

    const file = data['file'].map((srcfile, Index) => {
      let ex = srcfile.name.split('.').pop();

      return (
        <CCol md="2" key={Index} style={{ textAlign: 'center' }}>
          {(ex == 'docx' || ex == 'doc') && <FaFileWord style={{ width: '20px', height: '40px' }} />}
          {(ex == 'xlsx' || ex == 'xls') && <FaFileExcel style={{ width: '20px', height: '40px' }} />}

          {(ex == 'ppt' || ex == 'pptx') && <FaFilePowerpoint style={{ width: '20px', height: '40px' }} />}
          {ex == 'pdf' && <FaFilePdf style={{ width: '20px', height: '40px' }} />}
          {ex == 'csv' && <FaFileCsv sstyle={{ width: '20px', height: '40px' }} />}

          <div>
            <span style={{ fontSize: '10px' }}>
              <a href={srcfile.link} target="_blank" rel="noreferrer">
                {srcfile.name}
              </a>
            </span>
          </div>
        </CCol>
      );
    });

    const reply = data['reply'].map((rep, Index) => {
      let repstr = rep.reply.split('\n');
      const ReplyImg = rep['img'].map((url, Index) => {
        let src = url.link.toString();
        return (
          <CCol md="5" key={Index}>
            <img
              src={src}
              style={{
                width: '80%',
                height: '100%',
                borderRadius: '10px',
                marginLeft: '30px',
                borderStyle: 'solid',
                borderWidth: '1px',
                borderColor: '#DEDEE1',
                marginTop: '5px',
              }}
              onClick={() => clickImagePreview(url.link)}
            />
          </CCol>
        );
      });

      const Replydocs = rep['file'].map((name, Index) => {
        let ex = name.name.split('.').pop();

        return (
          <CCol md="3" key={Index} style={{ textAlign: 'center' }}>
            {(ex == 'docx' || ex == 'doc') && <FaFileWord style={{ width: '20px', height: '40px' }} />}
            {(ex == 'xlsx' || ex == 'xls') && <FaFileExcel style={{ width: '20px', height: '40px' }} />}

            {(ex == 'ppt' || ex == 'pptx') && <FaFilePowerpoint style={{ width: '20px', height: '40px' }} />}
            {ex == 'pdf' && <FaFilePdf style={{ width: '20px', height: '40px' }} />}
            {ex == 'csv' && <FaFileCsv sstyle={{ width: '20px', height: '40px' }} />}

            <div>
              <span style={{ fontSize: '10px' }} className="file_text">
                <a href={name.link} title={name.name}>
                  {name.name}
                </a>
              </span>
            </div>
          </CCol>
        );
      });

      return (
        <CCol md="12" style={{ padding: '0' }} key={Index}>
          {showReplyEdit == p_index.toString() + Index.toString() ? (
            <CCol md="12" className="fade-in">
              <div className="box">
                {!profilePic ? <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" className="img_comment" /> : <img src={profilePic} className="img_comment" />}

                <div style={{ marginLeft: '10px' }} className="border-2 border-black reply-box">
                  <MentionsInput placeholder="Write an update..." style={defaultStyle} value={replyValue} onChange={(e) => setReplyValue(e.target.value)} a11ySuggestionsListLabel={'Suggested mention'}>
                    <Mention trigger="@" data={fetchUsers} style={defaultMentionStyle} />
                  </MentionsInput>

                  <CRow>
                    {ReplyImgUpload}
                    {ReplydocsPreview}
                  </CRow>
                </div>
              </div>
              <CRow>
                <CCol md="1"></CCol>
                <CCol md="3">
                  <label className="upload-file">
                    <input multiple type="file" name="file" id="file-input" className="upload-button upload-file" accept=".jfif,.jpg,.jpeg,.png,.gif" onChange={uploadReply} />

                    <span>
                      <FaImage /> Add Photos
                    </span>
                  </label>
                </CCol>
                <CCol md="3">
                  <label className="upload-file">
                    <input multiple type="file" name="file" id="file-input" className="upload-button upload-file" onChange={uploadFilesReply} accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf,.csv" />

                    <span>
                      <FaPaperclip /> Add Files
                    </span>
                  </label>
                </CCol>
                <CCol md="3"></CCol>
                <CCol md="2">
                  <CButton color="aimhi-primary" size="sm" style={{ marginTop: '20px' }} block onClick={updateReply}>
                    Reply
                  </CButton>
                </CCol>
              </CRow>
            </CCol>
          ) : (
            <CCol md="12" style={{ marginTop: '10px' }} key={Index} onMouseEnter={() => setHoverDelete(p_index.toString() + Index.toString())} onMouseLeave={() => setHoverDelete()}>
              <div className="box">
                {rep.profile_img == '' ? <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" className="img_comment" /> : <img src={rep.profile_img} className="img_comment" />}

                <div style={{ marginLeft: '10px' }}>
                  <p className="comment-style">
                    <span style={{ fontWeight: 'bold' }}>{rep.name}</span> <br></br>
                    {repstr.map((item, index) => {
                      return <p key={index}>{item.replace(/(@)\[([\w\d\s.]+)\]\(\d+\)/gm, '$1$2')}</p>;
                    })}
                  </p>
                </div>
                {hoverDelet == p_index.toString() + Index.toString() && user_id == rep.user_id && (
                  <div>
                    <CDropdown className="m-1" size="sm">
                      <CDropdownToggle className="caret">
                        <FaEllipsisV />
                      </CDropdownToggle>
                      <CDropdownMenu>
                        <CDropdownItem onClick={() => editReply(p_index.toString() + Index.toString(), rep.reply_id, data.post_id, setReplyButtonChange('update'))} size="sm">
                          <FaPencilAlt style={{ marginRight: '5px' }} />
                          <span style={{ fontWeight: 'bold' }}>Edit Post</span>
                        </CDropdownItem>
                        <CDropdownItem size="sm" onClick={() => removeUpdates(rep.reply_id, 'reply')}>
                          <FaTrashAlt style={{ marginRight: '5px' }} />
                          <span style={{ fontWeight: 'bold' }}>Move to trash</span>
                        </CDropdownItem>
                      </CDropdownMenu>
                    </CDropdown>
                  </div>
                )}
              </div>

              {ReplyImg}
              {Replydocs}
            </CCol>
          )}
        </CCol>
      );
    });
    return (
      <CCard className="mt-5 rounded-lg shadow-lg">
        <CCardBody className="px-6 py-4">
          <div className="flex items-center justify-end mb-4">
            <span className="text-sm text-aimhi-textlight-neutral">{data.date_time}</span>
            {user_id === data.user_id && (
              <CDropdown size="sm">
                <CDropdownToggle className="p-1 caret">
                  <FaEllipsisV />
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem onClick={() => EditPost(data.post_id, setButtonChange('edit'), noteChange(data.note.replace(/\r\n/g, '\n')))}>
                    <FaPencilAlt className="inline mr-2" />
                    <span className="font-bold">Edit Post</span>
                  </CDropdownItem>
                  <CDropdownItem onClick={() => removeUpdates(data.post_id, 'post')}>
                    <FaTrashAlt className="inline mr-2" />
                    <span className="font-bold">Move to trash</span>
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            )}
          </div>

          <div className="flex items-center mb-4 ml-4">
            <img src={data.profile_img || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'} alt="Profile" className="object-cover w-10 h-10 rounded-full" />
            <span className="ml-3 font-semibold">{data.name}</span>
          </div>

          <div className="ml-4 space-y-4 text-aimhi-textlight-neutral">
            {data.note.split(/\r?\n/).map((line, idx) => (
              <p key={idx}>{line.replace(/(@)\[([^\]]+)\]\((\d+)\)/gm, '$1$2 ')}</p>
            ))}
          </div>
          {imageFile}
          {data.files?.length > 0 && (
            <div className="mt-4 space-y-2">
              {data.files.map((fileObj, idx) => (
                <a key={idx} href={fileObj.url} className="block underline">
                  {fileObj.name}
                </a>
              ))}
            </div>
          )}

          {data.likes > 0 && (
            <div className="flex items-center mt-4 ml-4">
              <img src={likeIcon} alt="likes" className="w-6 h-6" />
              <span className="ml-2 text-sm text-aimhi-textlight-neutral">{data.likes}</span>
            </div>
          )}
        </CCardBody>

        <CCardFooter className="px-6 py-3">
          <div className="flex gap-10 justify-evenly">
            <button onClick={() => like(data.post_id, user_id, data.has_liked ? 'unlike' : 'like')} className="flex items-center">
              <img src={data.has_liked ? likeIcon : unlikeIcon} alt="like-button" className="w-5 h-5" />
              <span className={'ml-2 text-sm ' + (data.has_liked ? 'text-aimhi-primary font-bold' : '')}>{data.has_liked ? 'Unlike' : 'Likes'}</span>
            </button>

            <button onClick={() => setShowReply(Index)} className="flex items-center text-sm">
              <FaReply className="mr-1" /> Reply
            </button>
          </div>
        </CCardFooter>

        {showReply === Index && (
          <CCardFooter className="px-6 py-4">
            <div className="space-y-4 animate-fadeIn">
              <div className="flex items-start">
                <img src={profilePic || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'} alt="Profile" className="object-cover w-10 h-10 rounded-full" />
                <div className="flex-1 ml-3 border-2 border-black">
                  <MentionsInput placeholder="Write an update..." style={defaultStyle} value={replyValue} onChange={(e) => setReplyValue(e.target.value)} a11ySuggestionsListLabel="Suggested mention">
                    <Mention trigger="@" data={fetchUsers} style={defaultMentionStyle} />
                  </MentionsInput>
                </div>
              </div>

              <div className="space-y-2">
                {ReplyImgUpload}
                {ReplydocsPreview}
              </div>

              <div className="flex flex-wrap justify-center gap-4">
                <label className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded cursor-pointer">
                  <input type="file" multiple accept="image/*" onChange={uploadReply} className="hidden" />
                  <FaImage /> Add Photos
                </label>

                <label className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded cursor-pointer">
                  <input type="file" multiple accept="*/*" onChange={uploadFilesReply} className="hidden" />
                  <FaPaperclip /> Add Files
                </label>

                <CButton color="aimhi-primary" size="sm" onClick={() => ReplyUpdate(data.post_id)} className="ml-auto">
                  Reply
                </CButton>
              </div>
            </div>

            {reply}
          </CCardFooter>
        )}
      </CCard>
    );
  });

  return (
    <>
      <ProjectTabs />
      <CRow>
        <CCol xs="6" sm="6" md="6" lg="6" xl="6" style={{ marginTop: '20px' }}>
          <CCol md="12" style={{ marginTop: '20px', padding: '0px' }}>
            {showPost == false && (
              <CCard
                onClick={() => {
                  setShowPost(true);
                  noteChange('');
                  setButtonChange('save');
                }}
                className="post-card-shadow"
              >
                <CCardBody>
                  <CCol md="12">
                    <CRow>
                      {!profilePic ? <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" className="img_post" /> : <img src={profilePic} className="img_post" />}

                      <div className="p-3 write-post" role="button">
                        <span>Write an update...</span>
                      </div>
                    </CRow>
                  </CCol>
                </CCardBody>
              </CCard>
            )}
          </CCol>
          {Updates}
        </CCol>
        <CCol md="12">
          <CRow>
            <CCol md="5"></CCol>
            <CCol md="2" style={{ textAlign: 'center' }}>
              <span>
                Viewing {limit > totalItems ? totalItems : limit} of {totalItems} project(s)
              </span>
              {limit <= totalItems && (
                <CButton color="aimhi-textlight-neutral" size="sm" variant="outline" block onClick={loadMore}>
                  Load More
                </CButton>
              )}
            </CCol>
            <CCol md="5"></CCol>
          </CRow>
        </CCol>
      </CRow>

      <CModal show={showPost} onClose={() => setShowPost(!showPost)} style={{ borderRadius: '5px' }}>
        <CModalBody style={{ padding: '5px' }}>
          <CCol md="12" sm="12" lg="12" xl="12" style={{ padding: '0px' }}>
            <CCard className="fade-in">
              <CCardBody>
                <CCol md="12">
                  {!profilePic ? <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" className="img_post" /> : <img src={profilePic} className="img_post" />}

                  <span className="name_post">{fullName}</span>
                </CCol>
                <CCol md="12" style={{ padding: '0px', marginTop: '20px' }}>
                  <CRow></CRow>
                  <MentionsInput
                    className=" notes"
                    placeholder="Write an update..."
                    style={defaultStyle}
                    value={notes}
                    onChange={(e) => {
                      noteChange(e.target.value);
                    }}
                    a11ySuggestionsListLabel={'Suggested mention'}
                  >
                    <Mention trigger="@" data={fetchUsers} style={defaultMentionStyle} />
                  </MentionsInput>
                </CCol>
                <CCol md="12" style={{ padding: '0px', marginTop: '20px' }}>
                  <CRow>{ImgUpload}</CRow>
                </CCol>
                <CCol md="12" style={{ padding: '0px', marginTop: '20px' }}>
                  <CRow>{docsPreview}</CRow>
                </CCol>
                <CCol md="12" style={{ padding: '0px' }}>
                  <CRow>
                    <CCol md="4">
                      <label className="upload-file">
                        <input multiple type="file" name="file" id="file-input" className="upload-button upload-file" accept=".jfif,.jpg,.jpeg,.png,.gif" onChange={upload} />

                        <span>
                          <FaImage /> Add Photos
                        </span>
                      </label>
                    </CCol>
                    <CCol md="3">
                      <label className="upload-file">
                        <input multiple type="file" name="file" id="file-input" className="upload-button upload-file" onChange={uploadFiles} accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf,.csv" />

                        <span>
                          <FaPaperclip /> Add Files
                        </span>
                      </label>
                    </CCol>
                    <CCol md="2"></CCol>
                    <CCol md="3">
                      {buttonChange == 'save' ? (
                        <CButton color="aimhi-textlight-neutral" size="sm" block onClick={saveUpdate}>
                          Update
                        </CButton>
                      ) : (
                        <CButton color="aimhi-textlight-neutral" size="sm" block onClick={updatePost}>
                          Update
                        </CButton>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
              </CCardBody>
            </CCard>
          </CCol>
        </CModalBody>
      </CModal>
      <CModal show={showImage} onClose={() => setShowImage(!showImage)} style={{ borderRadius: '5px' }} size="lg">
        <CModalBody>
          <CCol md="12">
            <img src={imagePreview} style={{ height: '100%', width: '100%' }} />
          </CCol>
        </CModalBody>
      </CModal>
    </>
  );
};

export default Updates;
